<div class="overflow-x-auto lg:overflow-x-scroll w-full">
  <table class="min-w-full divide-y divide-gray-200 shadow-md rounded-lg overflow-hidden table-auto">
    <thead class="bg-[#FAFAFA]">
      <tr>
        @for (column of columns; track $index) {
        <th [class]="headerCellClass(column)">
          {{ column.label }}
        </th>
        }
        @if (showOptions) {
        <th
          class="align-middle px-2 py-3 sm:py-4 text-xs font-medium bg-[#F7F7F7] text-[#636363] uppercase tracking-wider whitespace-nowrap">
          Actions
        </th>
        }
        @if (menuTemplate) {
        <th
          class="align-middle px-2 py-3 sm:py-4 text-xs font-medium bg-[#F7F7F7] text-[#636363] uppercase tracking-wider whitespace-nowrap">
          Actions
        </th>
        }
      </tr>
    </thead>

    @if ((data.length || 0) > 0 && isLoading() === false) {
    <tbody class="bg-white divide-y divide-gray-200">
      @for (row of data; track $index) {
      <tr class="hover:bg-gray-50 cursor-pointer">
        @for (column of columns; track column.key) {
        @if (cellTemplateFor(column.key); as cellTpl) {
        <td (click)="onRowClick(row)" [class]="bodyCellClass(column)">
          <ng-container
            [ngTemplateOutlet]="cellTpl"
            [ngTemplateOutletContext]="cellOutletContext(row)"
          />
        </td>
        } @else if (column.key === 'status' || column.key === 'statusDisplay') {
        <td (click)="onRowClick(row)" [class]="bodyCellClass(column)">
          @if (row[column.key]?.['pill']) {
          <lib-status-pill [variant]="row[column.key]['value'] || 'neutral'"
            [label]="row[column.key]['displayName'] || 'N/A'" />
          } @else {
          <span [ngClass]="{
            'text-success-600': row[column.key]['value'] === 'active',
            'text-warning': row[column.key]['value'] === 'pending',
            'text-error-500': row[column.key]['value'] === 'inactive'
          }" class="px-3 py-1 rounded-md text-xs font-semibold capitalize inline-block">
            {{ row[column.key]['displayName'] || 'N/A' }}
          </span>
          }
        </td>
        } @else {
        <td (click)="onRowClick(row)" [class]="bodyCellClass(column)">
          {{ row[column.key] ?? 'N/A' }}
        </td>
        }
        }
        @if (showOptions) {
        <td class="px-6 py-4 whitespace-nowrap text-sm text-end">
          <button (click)="onMoreOptions(row)"
            class="p-2 sm:p-2 hover:bg-gray-100 active:bg-gray-200 rounded-full transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 8a2 2 0 100-4 2 2 0 000 4zm0 2a2 2 0 100 4 2 2 0 000-4zm0 6a2 2 0 100 4 2 2 0 000-4z" />
            </svg>
          </button>
        </td>
        }
        @if (menuTemplate) {
        <td class="px-6 py-4 whitespace-nowrap text-sm text-end">
          <button [matMenuTriggerFor]="menuTemplate" (click)="onMenuOpen(row)"
            class="p-2 sm:p-2 hover:bg-gray-100 active:bg-gray-200 rounded-full transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="currentColor">
              <path
                d="M10 4.167q-.521 0-.885-.365-.365-.364-.365-.885 0-.521.365-.885.364-.365.885-.365.521 0 .885.365.365.364.365.885 0 .521-.365.885-.364.365-.885.365Zm0 5q-.521 0-.885-.365-.365-.364-.365-.885 0-.521.365-.885.364-.365.885-.365.521 0 .885.365.365.364.365.885 0 .521-.365.885-.364.365-.885.365Zm0 5q-.521 0-.885-.365-.365-.364-.365-.885 0-.521.365-.885.364-.365.885-.365.521 0 .885.365.365.364.365.885 0 .521-.365.885-.364.365-.885.365Z" />
            </svg>
          </button>
        </td>
        }
      </tr>
      }
    </tbody>
    }
  </table>

  @if (isLoading()) {
  <div class="min-h-[40vh] sm:min-h-[50vh] flex justify-center items-center px-4">
    <div>
      <div class="flex items-center justify-center">
        <span class="table-spinner"></span>
      </div>
      <p class="text-center mt-8">Please wait...</p>
    </div>
  </div>
  }

  @if (data.length === 0 && !isLoading()) {
  <div class="py-6 sm:py-10 px-4">
    <lib-empty-state></lib-empty-state>
    <p class="text-center">
      {{
      emptyStateMessage
      }}
    </p>
  </div>
  }
</div>
